import { useState } from 'react';
import { EMOTION_PRESET, EMOTIONS } from '../sketches/constants/presets';


export const useEmotionState = () => {
  const [isGifSaved, setIsGifSaved] = useState(false);

  const [options, setOptions] = useState({
    emotions: [EMOTIONS[0]],
    ...EMOTION_PRESET[EMOTIONS[0]],
    title: EMOTIONS[0],
    description: "Explore your emotions with beautiful sketches",
  });


    return {options, setOptions, isGifSaved, setIsGifSaved};
};